module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_black.fae3b406.png";